export default __webpack_public_path__ + "static/media/demo-01.f1caa21c.gif";